(() => {
  const SEATED_ROOT_SELECTOR = '[id^="seated-"]';
  const ROW_SELECTOR = ".seated-event-row";
  const DATE_CELL_SELECTOR = ".seated-event-date-cell";
  const KEYWORD = "Marc Roberge";
  const MATCH_COLOR = "#659411";

  // "short" => Mon, Tue... | "long" => Monday, Tuesday...
  const WEEKDAY_FORMAT = "short";

  // How weekday is displayed
  const JOINER = " • ";

  function hasWeekdayAlready(text) {
    return /\b(Mon|Tue|Wed|Thu|Thur|Fri|Sat|Sun|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)\b/i.test(text);
  }

  function parseSeatedDate(text) {
    const d = new Date(text);
    return isNaN(d.getTime()) ? null : d;
  }

  function applyEnhancements(root) {
    const rows = root.querySelectorAll(ROW_SELECTOR);

    rows.forEach(row => {
      const dateCell = row.querySelector(DATE_CELL_SELECTOR);
      if (dateCell && !dateCell.dataset.weekdayApplied) {
        const original = dateCell.textContent.trim();
        if (original && !hasWeekdayAlready(original)) {
          const d = parseSeatedDate(original);
          if (d) {
            const weekday = d.toLocaleDateString(undefined, { weekday: WEEKDAY_FORMAT });
            dateCell.innerHTML = `${weekday}${JOINER}${original}`;
            dateCell.dataset.weekdayApplied = "1";
          }
        } else {
          dateCell.dataset.weekdayApplied = "1";
        }
      }

      // Highlight date if row contains keyword anywhere
      const rowText = (row.textContent || "").toLowerCase();
      if (rowText.includes(KEYWORD.toLowerCase())) {
        
        row.style.color = MATCH_COLOR;

        // Optional: also bold the date cell slightly
        if (dateCell) dateCell.style.fontWeight = "700";

        row.classList.add("seated-keyword-match");
      }
    });
  }

  function run() {
    document.querySelectorAll(SEATED_ROOT_SELECTOR).forEach(root => applyEnhancements(root));
  }

  // Initial run
  run();

  // Watch for Seated async rendering / updates
  const observer = new MutationObserver(() => {
    // Batch calls into next frame
    window.requestAnimationFrame(run);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Safety stop after 30s (prevents permanent observers)
  setTimeout(() => observer.disconnect(), 30000);
})();